const state = {
    onlineUser: ['1']
  }
  const mutations = {
    SETINFO(state, info) {
      state.onlineUser = info;
    }
  }
  const actions = {
    // 设置信息
    setInfo({ commit }, userIdArr) {
      commit('SETINFO', userIdArr)
    }
  }
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  


// WEBPACK FOOTER //
// ./src/store/modules/onlineUser.js